import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

import { questionEditorStyles } from '../../../../../FTBEditor/styles';
import { submittedBlankStyles } from '../FtbBlank/styles';
import { BlankBoxProps } from './types';

const BlankBox: React.FC<BlankBoxProps> = (props) => {
  const { className, text, color } = props;

  return (
    <Box
      className={cn(
        'items-center rounded-8 px-30 me-16 xs:mb-12 xs:me-12',
        submittedBlankStyles,
        className,
      )}>
      <Typography className={questionEditorStyles} color={color} variant="body-long-01">
        {text}
      </Typography>
    </Box>
  );
};

export default BlankBox;
